import { render } from "./EcoFaultShortWorkingTime.vue?vue&type=template&id=aafd9178"
import script from "./EcoFaultShortWorkingTime.vue?vue&type=script&lang=js"
export * from "./EcoFaultShortWorkingTime.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__